import { Navigate } from 'react-router-dom';

export default function Home() {
  // Check if user is logged in
  const token = localStorage.getItem('auth_token');
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/landing" replace />;
}
